/**
 * External dependencies
 */

import { get, values } from 'lodash';


export const getAllVisualDeckPlans = (state) => values(get(state, ['visualDeckPlans', 'items']));

export const requestingVisualDeckPlans = (state) => get(state, ['visualDeckPlans', 'requesting']);

export const errorRequestingVisualDeckPlans = (state) => get(state, ['visualDeckPlans', 'error']);